import { useImageGeneratorTool } from '@/data/hook/editorjs/useImageGeneratorTool';
import { imageGenerationGenerator } from '@/data/services/astro.ai/generateServices';
import { AspectRatioEnum } from '@/models/astro.ai/generate/Image';

type UseMaterialImageGeneratorToolArgs = {
  lessonId?: number;
};

export default function useMaterialImageGeneratorTool({
  lessonId,
}: UseMaterialImageGeneratorToolArgs = {}) {
  const generateImage = async (prompt: string) => {
    const { imageUrl } = await imageGenerationGenerator({
      prompt,
      aspectRatio: AspectRatioEnum.SQUARE,
      lessonId,
    });
    return imageUrl;
  };

  return useImageGeneratorTool({ onGenerateImage: generateImage });
}
